/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, Card, CardContent, Grid } from "@mui/material";
import { Clear, Edit, Search } from "@mui/icons-material";
import { GridActionsCellItem, GridRowId, GridRowModel, GridSortDirection, GridSortModel } from "@mui/x-data-grid";
import { useEffect, useMemo, useState } from "react";

import { Container } from "../../../theme/globalStyles";
import DataTable from "../../../components/dataTable";
import DialogSearch from "./dialogSelectClient";
import InputNumber from "../../../components/hookForms/inputNumber";
import Tooltip from "@mui/material/Tooltip";
import messages from "../../../utils/messages";
import serviceRevisaoCotaInstalacao from "../../../services/serviceRevisaoCotaInstalacao";
import { toast } from "react-toastify";
import { useAuth } from "../../../context/global";
import { useForm } from "react-hook-form";

function RevisaoInstalacao(props: any) {
    const { setTitlePage } = useAuth();

    useEffect(() => {
        setTitlePage("Usinas - Revisão de Instalação");
    }, [setTitlePage]);

    const { handleGetDataUser } = useAuth();
    const user = handleGetDataUser();
    const isAdmin = user.perfil === "Admin";

    const [data, setData] = useState<any[]>([]);
    const [pageSize, setPageSize] = useState(100);
    const [page, setPage] = useState(0);
    const [filters, setFilters] = useState(null);
    const [rowCount, setRowCount] = useState(0);
    const [isLoading, setLoading] = useState(false);
    const [updateCliente, setUpdateCliente] = useState(false);
    const [editState, setEditState] = useState({
        open: false,
        nomeCliente: "",
        revisaoCotaInstalacaoID: 0,
    });

    const [sortModel, setSortModel] = useState<GridSortModel>([
        {
            field: "",
            sort: "" as GridSortDirection,
        },
    ]);

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useForm({
        defaultValues: { numeroInstalacao: "", clienteInstalacaoID: 0 },
    });

    const actionColumns = useMemo(
        () => [
            {
                headerName: "Operações",
                field: "operations",
                type: "actions",
                width: 140,
                hide: false,
                getActions: (params: { id: GridRowId; row: GridRowModel }) => [
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Editar">
                                <Edit />
                            </Tooltip>
                        }
                        label="Editar"
                        disabled={params.row.statusRevisaoCotaInstalacao === "Antigo" && !isAdmin}
                        onClick={() => {
                            setEditState({
                                open: true,
                                nomeCliente: params.row.nomeCliente,
                                revisaoCotaInstalacaoID: params.row.revisaoCotaInstalacaoID,
                            });
                        }}
                    />,
                ],
            },
        ],
        []
    );

    const columns = useMemo(
        () => [
            {
                headerName: "ID",
                field: "revisaoCotaInstalacaoID",
                type: "number",
                headerAlign: "left",
                identity: true,
                width: 70,
            },
            { headerName: "Usina", field: "nomeUsina", type: "string", width: 200 },
            {
                headerName: "Revisão",
                field: "numeroRevisao",
                type: "number",
                headerAlign: "left",
                width: 120,
            },
            { headerName: "Status", field: "statusRevisaoCotaInstalacao", type: "string", width: 90 },
            {
                headerName: "Inst. Cliente",
                field: "clienteInstalacaoID",
                type: "number",
                headerAlign: "left",
                width: 100,
            },
            {
                headerName: "Cliente",
                field: "nomeCliente",
                type: "string",
                width: 200,
            },
            {
                headerName: "Instalação",
                field: "numeroInstalacao",
                type: "number",
                headerAlign: "left",
                width: 180,
            },
            {
                headerName: "Percentual (%)",
                field: "percentualInstalacaoUsina",
                type: "number",
                headerAlign: "left",
                width: 140,
            },
            {
                headerName: "Consumo previsto",
                field: "consumoPrevisto",
                type: "number",
                headerAlign: "left",
                width: 160,
            },
            ...actionColumns,
        ],
        [actionColumns]
    );

    const getAllWithFilters = async (filters: any) => {
        setData([]);
        setLoading(true);

        serviceRevisaoCotaInstalacao
            .getWithFilter({
                ...filters,
                take: pageSize,
                currentPage: page + 1,
                sortExpression: sortModel[0]?.field ?? "",
                sortDirection: sortModel[0]?.sort ?? "",
            })
            .then((result) => {
                setData(result?.data.content);
                setRowCount(result?.data.numberOfElements);
            })
            .catch((err) => {
                toast.error(messages.getWithFilterError, err);
                setData([]);
                setRowCount(0);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(
        () => {
            if (props && props.location && props.location.state) {
                getAllWithFilters(props.location.state);
            } else {
                getAllWithFilters(filters);
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [props, page, pageSize, sortModel]
    );

    const onSubmit = (values: any) => {
        const newFilters = {
            ...values,
        };
        setFilters(newFilters);
        getAllWithFilters(newFilters);
    };

    useEffect(() => {
        if (props && props.location && props.location.state) {
            reset(props.location.state);
            setFilters(props.location.state);
            getAllWithFilters(props.location.state);
        }
    }, [props]);

    const onClear = () => {
        reset({ numeroInstalacao: "", clienteInstalacaoID: 0 });
        if (props && props.location && props.location.state) {
            getAllWithFilters(props.location.state);
        } else {
            getAllWithFilters(null);
        }
    };

    useEffect(() => {
        if (props && props.location && props.location.state) {
            getAllWithFilters(props.location.state);
        } else {
            getAllWithFilters(null);
        }
    }, [updateCliente]);

    return (
        <Container>
            <Card>
                <CardContent>
                    <Box sx={{ mb: 2 }}>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Grid container spacing={2}>
                                <Grid item md={12}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={8}>
                                            <InputNumber
                                                id="numeroInstalacao"
                                                name="numeroInstalacao"
                                                label="Instalação"
                                                control={control}
                                                error={errors}
                                                decimalScale={0}
                                                noThousandSeparator
                                                maxLength={15}
                                            />
                                        </Grid>
                                        <Grid item md={2}>
                                            <Button
                                                id="pesquisar"
                                                disableElevation
                                                variant="contained"
                                                color="warning"
                                                fullWidth
                                                style={{ margin: "16px 0px 8px 0px" }}
                                                startIcon={<Search />}
                                                type="submit"
                                                disabled={isLoading}
                                            >
                                                Pesquisar
                                            </Button>
                                        </Grid>

                                        <Grid item xs={12} md={2}>
                                            <Button
                                                id="limpar"
                                                disableElevation
                                                variant="outlined"
                                                color="warning"
                                                fullWidth
                                                style={{ margin: "16px 0px 8px 0px" }}
                                                startIcon={<Clear />}
                                                onClick={() => onClear()}
                                            >
                                                Limpar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </form>
                    </Box>

                    <Box sx={{ height: 450 }}>
                        <DataTable
                            columns={columns}
                            rows={data}
                            rowId={(row: GridRowModel) => row.revisaoCotaInstalacaoID}
                            rowCount={rowCount}
                            isLoading={isLoading}
                            onPageChange={(currentPage: number) => setPage(currentPage)}
                            onPageSizeChange={(currentPageSize: number) => setPageSize(currentPageSize)}
                            pageSize={pageSize}
                            onSortModelChange={(model: GridSortModel) => setSortModel(model)}
                        />
                    </Box>

                    <DialogSearch
                        success={() => setUpdateCliente(true)}
                        data={{
                            open: editState.open,
                            nomeCliente: editState.nomeCliente,
                            revisaoCotaInstalacaoID: editState.revisaoCotaInstalacaoID,
                        }}
                        onClose={() => setEditState({ open: false, nomeCliente: "", revisaoCotaInstalacaoID: 0 })}
                    />
                </CardContent>
            </Card>
        </Container>
    );
}

export default RevisaoInstalacao;
